module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "CONTENTS",
      "src": "images/content.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "normal mtop1 mleft"
  }, [_c('a', {
    attrs: {
      "href": "#/f007"
    }
  }, [_c('span', {
    staticClass: "no-style-override-32"
  }, [_vm._v("Acknowledgments ")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal mtop mleft"
  }, [_c('a', {
    attrs: {
      "href": "#/f008"
    }
  }, [_c('span', {
    staticClass: "no-style-override-32"
  }, [_vm._v("Harvey Louis Carignan ")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal mtop mleft"
  }, [_c('a', {
    attrs: {
      "href": "#/f009"
    }
  }, [_c('span', {
    staticClass: "no-style-override-32"
  }, [_vm._v("Arthur John Shawcross ")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal mtop mleft"
  }, [_c('span', {
    attrs: {
      "href": "#/f010",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "no-style-override-32"
  }, [_vm._v("John Martin Scripps ")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal mtop mleft"
  }, [_c('span', {
    attrs: {
      "href": "#/f011",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "no-style-override-32"
  }, [_vm._v("Michael Bruce Ross")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal mtop mleft"
  }, [_c('span', {
    attrs: {
      "href": "#/f012",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "no-style-override-32"
  }, [_vm._v("Ronald Joseph ‘Butch’ DeFeo Jr")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "normal mtop mleft"
  }, [_c('span', {
    attrs: {
      "href": "#/f013",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "no-style-override-32"
  }, [_vm._v("Aileen Carol Wuornos ")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal mtop mleft"
  }, [_c('span', {
    attrs: {
      "href": "#/f014",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "no-style-override-32"
  }, [_vm._v("Kenneth Allen McDuff ")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal mtop mleft"
  }, [_c('span', {
    attrs: {
      "href": "#/f015",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "no-style-override-32"
  }, [_vm._v("Douglas Daniel Clark & Carol ")]), _c('span', {
    staticClass: "no-style-override-33"
  }, [_vm._v("Mary Bundy ")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal mtop mleft"
  }, [_c('span', {
    attrs: {
      "href": "#/f016",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "no-style-override-32"
  }, [_vm._v("Henry Lee Lucas")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24716202","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/f006.vue
// module id = 72
// module chunks = 0